import { render, staticRenderFns } from "./About.vue?vue&type=template&id=06121a23&scoped=true&lang=pug&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=06121a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06121a23",
  null
  
)

export default component.exports